import { useEvent } from '@pum-spark/react-hooks';
import { useQueryClient } from '@tanstack/react-query';
import { FunctionOr } from '../types/FunctionOr';
import { unwrap } from '../helpers/unwrap';

export function useSetQueryData<T = unknown>(queryKey: any[] | readonly any[]) {
    const queryClient = useQueryClient();
    return useEvent((valueOrUpdater: FunctionOr<T>) => {
        queryClient.setQueryData<T>(queryKey, data => {
            return unwrap(valueOrUpdater, data);
        });
    });
}
